export interface ErrorReporter {
  captureException(error: unknown, context?: Record<string, unknown>): void;
}

/** Placeholder until an external service (e.g. Sentry) is wired up — mirrors the backend's
 *  `NoopErrorReporter` (backend/src/common/error-reporter). Swap the export, not the call sites. */
class NoopErrorReporter implements ErrorReporter {
  captureException(): void {}
}

export const errorReporter: ErrorReporter = new NoopErrorReporter();
